import { useState } from "react";
import { api, errorText } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { PrimaryButton, SecondaryButton } from "@/components/shared/ui";
import { ErrorBox } from "@/components/applicant/stageUi";

/** [Explain]: a free-text note saved on the latest result, for the agent. */
export const ExplainBox = ({ token, docId, note, onSaved, onClose, testid }) => {
  const [text, setText] = useState(note || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const save = async () => {
    setBusy(true);
    setError("");
    try {
      await api.post(`/a/${token}/documents/${docId}/note`, { note: text.trim() });
      await onSaved();
      onClose();
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-4 flex flex-col gap-2" data-testid={testid}>
      <label className="text-sm font-medium" htmlFor={`${testid}-input`}>Explain this to the agent</label>
      <Textarea id={`${testid}-input`} value={text} onChange={(e) => setText(e.target.value)} maxLength={1000} rows={4}
        placeholder="For example: I changed jobs in August, or part of my pay goes to a savings account."
        className="text-base" data-testid={`${testid}-input`} />
      <p className="text-xs text-muted-foreground">Saved with this step. The agent reads it when they review your application.</p>
      {error && <ErrorBox>{error}</ErrorBox>}
      <PrimaryButton size="lg" onClick={save} isLoading={busy} disabled={!text.trim()} testid={`${testid}-save`}>Save note</PrimaryButton>
      <SecondaryButton size="lg" onClick={onClose} testid={`${testid}-cancel`}>Cancel</SecondaryButton>
    </div>
  );
};

export const SavedNote = ({ note, testid }) =>
  note ? (
    <p className="mt-2 rounded-lg bg-panel p-3 text-sm" data-testid={testid}>
      <span className="font-medium">Your note for the agent: </span>{note}
    </p>
  ) : null;
